import { createAction } from "@reduxjs/toolkit"

import { USER_SLICE_NAME } from "./user.constants"

// Plain actions shared between user.thunks.js (dispatches them mid-flow, mirroring what
// the legacy saga did with `yield put(UserActions.x(...))`) and user.slice.js (reacts to
// them via `extraReducers`). Kept in their own file so neither of those two files needs
// to import the other — the slice already imports the thunks for their `pending` cases,
// so the reverse edge would be a circular dependency.
export const userSetProp = createAction(`${USER_SLICE_NAME}/userSetProp`)
export const changeNextCreateAccountStep = createAction(
  `${USER_SLICE_NAME}/changeNextCreateAccountStep`
)
export const setDemoTourStep = createAction(`${USER_SLICE_NAME}/setDemoTourStep`)

export const restartCreateAccountAtCompanyStep = createAction(
  `${USER_SLICE_NAME}/restartCreateAccountAtCompanyStep`
)

// `attachPaymentSuccess` is both the fulfilled state of the `attachPayment` thunk and a
// standalone action the `createBillingDescriptor` thunk fires when onboarding finishes
// without a payment step — exactly as the legacy saga did.
export const attachPaymentSuccess = createAction(`${USER_SLICE_NAME}/attachPaymentSuccess`)

// `createBillingDescriptor` dispatches its own success instead of relying on `fulfilled`:
// its success reducer bumps `nextCreateAccountStep`, and the thunk's follow-up branches
// read and then clear that same field, so the reducer has to run first.
export const createBillingDescriptorSuccess = createAction(
  `${USER_SLICE_NAME}/createBillingDescriptorSuccess`
)

// Dispatched by `useFetchUserPreferences` with the `GET /user/preferences/` payload
// (`{feature_name: {data, updated_at}}`). Each feature's own reducer listens for this type
// directly (e.g. `AlertsPage/reducer.js`'s `applyPreferences`) and applies its own
// `payload[feature_name].data` - there's no central "preferences" slice.
export const preferencesSuccess = createAction(`${USER_SLICE_NAME}/preferencesSuccess`)
